import React, { memo } from 'react';
import SVG from 'react-inlinesvg';
import styles from './stepTitle.module.scss';

export default memo(function StepTitle(props) {
    return (
        <div className={styles.container}>
            <div className={styles.titleContainer}>
                <SVG cacheGetRequests={true} className={styles.icon} src={`./icons/${props.activeStepKey}.svg`} />
                <span className={styles.title}>{props.t(props.activeStepTitle)}</span>
            </div>
        </div>
    );
});
